(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footwear-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ss-parallax')) {
    /* One shared listener and one rAF frame for every parallax band on the
       page. Elements are only measured while they are actually on screen. */
    const live = new Set();
    let queued = false;
    let observer = null;

    const frame = () => {
      queued = false;
      const vh = window.innerHeight;
      live.forEach((el) => {
        const rect = el.getBoundingClientRect();
        /* -1 when the band is just below the fold, 1 when just above it. */
        const progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        const shift = Math.max(-1, Math.min(1, progress)) * el.depth;
        if (el.img) el.img.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
      });
    };

    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(frame);
    };

    customElements.define('ss-parallax', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        this.img = this.querySelector('img');
        if (!this.img) return;

        /* Travel in pixels, half above the rest position and half below. */
        this.depth = Number(this.dataset.depth || 40);
        if (!this.depth) return;

        if (!observer) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) live.add(entry.target);
              else live.delete(entry.target);
            });
            if (live.size) schedule();
          }, { rootMargin: '15% 0px' });

          window.addEventListener('scroll', () => { if (live.size) schedule(); }, { passive: true });
          window.addEventListener('resize', () => { if (live.size) schedule(); }, { passive: true });
        }

        observer.observe(this);
        schedule();
      }

      disconnectedCallback() {
        live.delete(this);
        observer?.unobserve(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const head = document.querySelector('[data-head]');
    if (!head) return;

    const toggle = head.querySelector('[data-menu-toggle]');
    const panel = head.querySelector('[data-menu-panel]');

    if (toggle && panel) {
      const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      };
      toggle.hidden = false;
      setOpen(false);
      toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) setOpen(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
      window.matchMedia('(min-width: 1100px)').addEventListener('change', (event) => {
        if (event.matches) setOpen(false);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = event.target.closest('[data-head] details[open]');
      if (!open) return;
      open.open = false;
      open.querySelector(':scope > summary')?.focus();
    });
    document.addEventListener('click', (event) => {
      head.querySelectorAll('.ss-head__nav details[open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
  })();

  /* The storefront's reveal: content rises slowly into place. Elements start
     visible and the observer opts them in, so a blocked script can never leave
     the page blank. */
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    const targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.dataset.reveal = 'in';
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

    targets.forEach((target) => {
      const delay = Number(target.dataset.revealDelay || 0);
      target.style.transitionDelay = `${Math.min(delay, 6) * 110}ms`;
      target.dataset.reveal = 'pending';
      observer.observe(target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ss-product-recommendations')) {
    customElements.define('ss-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded || this.querySelector('.ss-recommendations')) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '400px' });
        this.observer.observe(this);
      }
      async load() {
        this.loaded = true;
        this.controller = new AbortController();
        try {
          const response = await fetch(this.dataset.url, { signal: this.controller.signal });
          if (!response.ok) return;
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = documentFragment.querySelector('ss-product-recommendations .ss-recommendations');
          if (content) this.replaceChildren(content);
        } catch { /* No recommendations section is shown when Shopify cannot supply it. */ }
      }
      disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('ss-sticky-buy')) {
    customElements.define('ss-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        if (!('IntersectionObserver' in window)) return;

        const watched = document.querySelector(this.dataset.watch);
        if (!watched) return;

        /* Shown only once the inline add-to-cart has scrolled out of view. */
        this.observer = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.observer.observe(watched);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
